import React from 'react';

export const SingleSelectAnswerField = ({
	options = [],
	fieldValue = null,
	onAnswerChange
}) => {
	
	return (
		<div>
			<select className='form-select w-auto'
				value={fieldValue}
				onChange={(e) => onAnswerChange(e.target.value)}>
				<option value={null}>Select</option>
				{
					options?.map((opt) => (
						<option key={opt.id} value={opt.id}>{opt.name}</option>
					))
				}
			</select>
		</div>
	);
};

export default SingleSelectAnswerField;
